import React from "react";

interface ScoreBarProps {
  score: number; // 0 - 100
}

export function ScoreBar({ score }: ScoreBarProps) {
  const clampScore = Math.min(100, Math.max(0, score));
  const caretPosition = `${clampScore}%`;

  return (
    <div className="relative w-full h-3 rounded-full bg-gradient-to-r from-green-400 via-yellow-400 to-red-500 via-30%">
      <div
        className="absolute flex flex-col justify-center items-center gap-2 -top-1/2 text-black"
        style={{ left: caretPosition }}
      >
        <svg className="relative top-px" width="8" height="8" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
          <polygon points="0,0 24,0 12,24" />
        </svg>
        <svg className="relative bottom-px" width="8" height="8" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
          <polygon points="12,0 24,24 0,24" />
        </svg>
      </div>
    </div>
  );
}
